// import { getLocales } from "expo-localization";
import { I18n } from 'i18n-js';
import en from '@/locales/en.json';
// import es from '@/locales/es.json';

// It should be uncomment to support another language than "en"
// export const deviceLanguage = getLocales()?.[0]?.languageCode ?? "en";

export const i18n = new I18n({
  en
  // ,es
});

// Forcing "en"
i18n.defaultLocale = 'en'; //deviceLanguage;
i18n.locale = 'en'; //deviceLanguage;

export function changeLanguage(lang: string) {
  i18n.locale = lang;
}
